import { memo } from 'react';
import PropTypes from 'prop-types';
import { FaRegCheckCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import TextReadMore from '../../../../TextReadMore';

const AgentPreferencesInfo = ({
  isAgentPreferredHotel, informationAddedByAgent,
}) => {
  const { travelAgency = {} } = useSelector((store) => store.user);
  const agentPreferedHotelLabel = ((travelAgency || {}).settings || {}).agentPreferedHotelLabel || 'On your agency preferred list';
  const doHideAgentPreferedHotelLabel = travelAgency && travelAgency.settings
  && travelAgency.settings.hideAgentPreferedHotelLabel;

  return (isAgentPreferredHotel && !doHideAgentPreferedHotelLabel && (
  <div className="text-sm -mt-1 bg-theme bg-opacity-10 p-2 rounded-md" style={{ width: 'max-content' }}>
    {isAgentPreferredHotel && (
    <div className="text-green-600 text-preferenceLabelColor-0 font-bold mr-3">
      <FaRegCheckCircle className="inline -mt-1" />
      {' '}
      <span>{agentPreferedHotelLabel}</span>
    </div>
    )}
    {informationAddedByAgent && (
    <TextReadMore text={informationAddedByAgent} />
    )}
  </div>
  ));
};

AgentPreferencesInfo.propTypes = {
  isAgentPreferredHotel: PropTypes.bool,
  informationAddedByAgent: PropTypes.string,
};

AgentPreferencesInfo.defaultProps = {
  isAgentPreferredHotel: false,
  informationAddedByAgent: '',
};

export default memo(AgentPreferencesInfo);
